global.googletag = global.googletag || {};
global.googletag.cmd = global.googletag.cmd || [];

const requestIdleCallback = window.requestIdleCallback || setTimeout;
const containers = document.querySelectorAll('.rdp-ad');
const noAds = window.location.search.indexOf('no-ads=true') > 0;

if (!noAds && containers.length > 0) {
  global.googletag.cmd.push(() => {
    global.googletag.pubads().disableInitialLoad();
    global.googletag.pubads().enableSingleRequest();
    global.googletag.enableServices();

    const slots = [];
    for (let container of containers) {
      const read = (key) => container.attributes[key].value;
      const adUnitPath = read('data-ad-unit-path');
      const width = Number(read('data-ad-width'));
      const height = Number(read('data-ad-height'));
      const slotId = container.id;
      const position = read('data-ad-targets-position');
      const ages = read('data-ad-targets-ages').split(' ');
      const subjects = read('data-ad-targets-subjects').split(' ');

      const slot = global.googletag
        .defineSlot(adUnitPath, [width, height], slotId)
        .addService(global.googletag.pubads())
        .setTargeting('RDP_Position', position)
        .setTargeting('ages', ages)
        .setTargeting('subjects', subjects);
      global.googletag.display(slotId);
      slots.push(slot);
    }

    requestIdleCallback(() => {
      global.googletag.pubads().refresh(slots);
    });
  });
}
